<!-- 编辑职位 -->
<template>
  <div class="edit-boxs">
    <!-- 导航栏  #left-->
    <van-nav-bar title="编辑职位" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!--期望职位-->
    <div class="edit-item">
      <p>职位名称</p>
      <input type="text" placeholder="如：销售经理" class="printf-input" v-model="name" />
    </div>
    <!-- 薪资要求 -->
    <div class="edit-item degree" @click="edcutionShow=true">
      <div>
        <p>学历要求</p>
        <input type="text" placeholder="请选择" class="printf-input" v-model="edcution" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="edcutionShow" round position="bottom">
      <van-picker
        title="学历选择"
        show-toolbar
        value-key="name"
        :columns="edcutionList"
        @confirm="selectEdcution"
        @cancel="edcutionShow=false"
      />
    </van-popup>
    <!-- 经验要求 -->
    <div class="edit-item degree" @click="address=true">
      <div>
        <p>经验要求</p>
        <input type="text" placeholder="请选择经验要求" class="printf-input" v-model="workArea" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="address" round position="bottom">
      <van-picker
        title="工作年限"
        show-toolbar
        :columns="worhAddress"
        @confirm="selectAddre"
        @cancel="address=false"
        value-key="name"
      />
    </van-popup>
    <!-- 薪资要求 -->
    <div class="edit-item degree" @click="showPickers=true">
      <div style="width:80%">
        <p>薪资范围</p>
        <!-- <input
          type="number"
          placeholder="例如：0（面议）或 3000.5000 "
          class="printf-input"
          v-model="price"
        />-->
        <div class="price-box">
          <input type="number" v-model="minPrice" placeholder="输入最低薪资" class="price-item" />~
          <input type="number" v-model="maxPrice" placeholder="输入最高薪资" class="price-item" />
        </div>
        <span style="font-size:0.1rem">注：薪资面议薪资范围请输入0</span>
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <!-- <van-popup v-model="showPickers" round position="bottom">
      <van-picker
        title="薪资选择"
        show-toolbar
        :columns="salary"
        @confirm="selectSalary"
        @cancel="showPickers=false"
      />
    </van-popup>-->
    <!-- 招聘人数 -->
    <div class="edit-item degree" @click="Num=true">
      <div>
        <p>招聘人数</p>
        <input type="text" placeholder="请选择招聘人数" class="printf-input" v-model="numPeople" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="Num" round position="bottom">
      <van-picker
        title="招聘人数"
        show-toolbar
        :columns="needNum"
        @confirm="selectNum"
        @cancel="Num=false"
        value-key="name"
      />
    </van-popup>
    <!-- 工作地点 -->
    <div class="edit-item degree" @click="selectAddr">
      <div>
        <p>工作地点</p>
        <input
          type="text"
          placeholder="请选择工作地点"
          class="printf-input"
          :value="companyAddress[0]"
          disabled
        />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <!--期望职位-->
    <div class="edit-item">
      <p>相关福利</p>
      <span
        :class="{'li':true,'lis':item.selected==true}"
        v-for="(item, index) in tag"
        :key="index"
        @click="bindTag(index,item.category_id)"
      >{{item.name}}</span>
    </div>
    <div class="edit-item" @click="navLink">
      <p>职位描述</p>
      <van-field
        v-model="descript"
        rows="5"
        autosize
        type="textarea"
        placeholder="描述你在该公司的主要工作内容"
        :readonly="true"
        v-show="query==''"
      />
      <div v-show="query!=''" v-html="descript" class="van-cell"></div>
    </div>
    <div class="placeholder">
      <div class="btn">
        <button class="clear" @click="deletes" v-show="query.job_id">删除</button>
        <button class="confirm" @click="savePosition" :style="query.job_id?'':'margin:0'">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { mapState, mapMutations } from "vuex";
import {
  releasePosition,
  getKindArray,
  getAreaKinds,
  releaseDetails,
  edit,
  releaseDelete
} from "@/api/apiData";
export default {
  name: "index",
  inject: ["reload"],
  components: {},
  data() {
    return {
      idx: -1,
      showPickers: false, //薪资弹窗
      minPrice: "", //最低薪资
      maxPrice: "", //最高薪资
      name: "",
      edcution: "", //学历
      edId: "", //学历id
      edcutionShow: false,
      edcutionList: [],
      workArea: "",
      tagId: [],
      workId: "", //工作经验id
      tag: [], //福利标签
      address: false,
      addr: "", //地址
      addrId: "", //地址id
      salary_type: -1,
      query: "",
      // wageList: [],
      // salary: [
      //   "面议",
      //   "3k以下",
      //   "3-5k",
      //   "5-8k",
      //   "8-12K",
      //   "12-20k",
      //   "20-25k",
      //   "25k以上"
      // ],
      worhAddress: ["无经验要求", "一年以内", "1-3年", "3-5年", "5年以上"], //经验要求
      needNum: ["不限", "1人", "2人", "3人", "4人", "5人"], //招聘人数
      numPeople: "", //人数
      Num: false,
      descript: "",
      max_salary: "",
      details: ""
    };
  },
  computed: {
    ...mapState(["companyAddress", "companyRelseInfo"])
  },
  methods: {
    ...mapMutations(["selectAddress", "keepAliveRouter"]),
    //   返回上一页
    goBack() {
      this.selectAddress(["", "", 2]);
      this.$router.back();
    },
    navLink() {
      this.$router.replace({
        path: "./description",
        query: {
          descript: this.descript
        }
      });
    },
    // 选择学历
    selectEdcution(val) {
      var that = this;
      that.edcution = val.name;
      that.edId = val.category_id;
      that.edcutionShow = false;
    },
    //选择薪资
    // selectSalary(val) {
    //   var that = this;
    //   //(val);
    // switch (val) {
    //   case "面议":
    //     that.salary_type = 1;
    //     that.wageList = ["", ""];
    //     break;
    //   case "3k以下":
    //     that.wageList = ["", "3000"];
    //     that.salary_type = 0;
    //     break;
    //   case "25k以上":
    //     that.wageList = ["25000", ""];
    //     that.salary_type = 0;
    //     break;
    // }
    // if (val.lastIndexOf("k") != -1 && val.lastIndexOf("以") == -1) {
    //   var arr = val.split("-");
    //   that.wageList = [`${arr[0]}000`, arr[1].replace("k", "000")];
    //   that.salary_type = 0;
    // }
    // that.price = val;
    // that.showPickers = false;

    // },
    //选择经验要求
    selectAddre(val) {
      this.workArea = val.name;
      this.workId = val.category_id;
      this.address = false;
    },
    // 选择工作地点
    selectAddr(val) {
      var that = this;
      that.$router.push({
        name: "Address",
        query: {
          entrance: "2"
        }
      });
    },
    // 选择福利
    bindTag(val, id) {
      var that = this;
      that.tag[val].selected = !that.tag[val].selected;
      if (that.tag[val].selected) {
        that.tagId = that.tagId.concat(id);
      } else {
        that.tagId.forEach((item, index) => {
          if (item == id) {
            that.tagId.splice(index, 1);
          }
        });
      }
      that.idx = val;
    },
    // 招聘人数
    selectNum(val) {
      this.numPeople = val;
      this.Num = false;
    },
    // 删除
    deletes() {
      Dialog.confirm({
        title: "删除",
        message: "是否删除该职位"
      })
        .then(() => {
          releaseDelete({ job_id: this.query.job_id }).then(res => {
            if (res.code == 1) {
              Toast.success({
                forbidClick: true,
                message: "删除成功"
              });
              setTimeout(() => {
                this.$router.go(-2);
              }, 2500);
            } else {
              Toast(res.msg);
            }
            //  //(res);
          });
        })
        .catch(() => {});
    },
    // 发布职位
    savePosition() {
      var that = this;
      let {
        name,
        edId,
        workId,
        numPeople,
        companyAddress,
        tagId,
        salary_type,
        descript,
        minPrice,
        maxPrice
      } = that;
      if (numPeople == "不限") {
        numPeople = 0;
      } else {
        numPeople = numPeople.replace("人", "");
      }
      /**
       * 输入验证
       *
       * **/

      if (name.replace(/[, ]/g, "").length == 0) {
        Toast("请输入正确的职位名称");
        return false;
      }
      if (edId === "") {
        Toast("请选择学历");
        return false;
      }
      if (workId === "") {
        Toast("请选择经验要求");
        return false;
      }
      // if (price.replace(/[, ]/g, "").length == 0) {
      //   Toast("请输入薪资范围");
      //   return false;
      // } else {
      //   if (price.indexOf(".") == -1 && price != 0) {
      //     Toast("请按提示的格式输入");
      //     return false;
      //   } else {
      //     if (price != 0) {
      //       var index = price.split(".");
      //       if (index[0] > index[1]) {
      //         Toast("最低工资不能大于最高工资");
      //         return false;
      //       }
      //     } else {
      //     }
      //   }
      // }
      if (
        minPrice.replace(/[, ]/g, "").length == 0 ||
        maxPrice.replace(/[, ]/g, "").length == 0
      ) {
        Toast("请输入薪资范围");
        return false;
      } else {
        if (minPrice == 0 && maxPrice == 0) {
          salary_type = 1;
        } else {
          salary_type = 0;
        }

        if (Number(minPrice) > Number(maxPrice)) {
          Toast("最低工资不能大于最高工资");
          return false;
        }
      }

      if (numPeople === "") {
        Toast("请选择招聘人数");
        return false;
      }
      if (companyAddress.length == 0) {
        Toast("请选择工作地点");
        return false;
      }
      // if (that.addrId == "") {
      //   Toast("请选择工作地点");
      //   return false;
      // }
      if (descript.replace(/[, ]/g, "").length == 0) {
        Toast("请填写职位描述");
        return false;
      }
      if (tagId.length > 6) {
        Toast("最多只能添加6个哦~");
        return false;
      }

      let obj = {
        name: name,
        district: companyAddress[1],
        amount: numPeople,
        tag: tagId.toString(),
        experience: workId,
        education: edId,
        salary_type: salary_type,
        min_salary: salary_type == 0 ? minPrice : "",
        max_salary: salary_type == 0 ? maxPrice : "",
        description: descript,
        job_id: that.query.job_id ? that.query.job_id : ""
      };

      if (that.query.job_id) {
        edit(obj).then(res => {
          if (res.code == 1) {
            Toast.success({
              forbidClick: true,
              message: "修改成功"
            });
            that.selectAddress([]);
            setTimeout(() => {
              that.$router.replace({
                name: "Ment"
              });
            }, 1500);
          } else {
            Toast(res.msg);
          }
        });
      } else {
        releasePosition(obj).then(res => {
          // //(res);
          if (res.code == 1) {
            that.keepAliveRouter("1");
            that.selectAddress([]);
            Toast.success({
              forbidClick: true,
              message: "添加成功"
            });
            //  window.location.reload();
            setTimeout(() => {
              that.$router.replace({
                name: "Ment"
              });
            }, 1500);
          } else {
            Toast(res.msg);
          }
        });
      }
    },
    // 获取分类
    getKinds() {
      var that = this;
      // 获取经验分类
      getKindArray({ key: "experience" }).then(res => {
        // //(res);
        if (res.code == 1) {
          that.worhAddress = res.data;
        }
      });
      // 获取学历分类
      getKindArray({ key: "education" }).then(res => {
        // //(res);
        if (res.code == 1) {
          that.edcutionList = res.data;
        }
      });
      // 福利标签分类
      getKindArray({ key: "jobtag" }).then(res => {
        // //(res);
        if (res.code == 1) {
          var list = res.data;
          list.forEach(item => {
            item.selected = false;
          });
          that.tag = res.data;
          // 获取发布详情
          if (that.query.job_id) {
            let obj = {
              job_id: that.query.job_id
            };
            releaseDetails(obj).then(res => {
              //(res);
              if (res.code == 1) {
                that.name = res.data.name; //职位名称
                that.edcution = res.data.education; //学历
                that.workArea = res.data.experience; //经验要求
                let worhAddress = that.worhAddress;
                worhAddress.forEach(item => {
                  // //(item);
                  if (item.name == res.data.experience) {
                    // //(111);
                    that.workId = item.category_id;
                    // //(that.workId);
                  }
                });
                that.minPrice =
                  res.data.salary_type == 1 ? 0 : res.data.min_salary; //薪资要求
                that.maxPrice =
                  res.data.salary_type == 1 ? 0 : res.data.max_salary; //薪资要求
                that.numPeople =
                  res.data.amount == 0 ? "不限" : res.data.amount; //招聘人数
                that.addr = res.data.district_name; //工作地点
                that.addrId = res.data.district; //工作地点id
                let list = res.data.tag;
                let tag = that.tag;
                let edcutionList = that.edcutionList;
                edcutionList.forEach(i => {
                  if (i.name == res.data.education) {
                    that.edId = i.category_id;
                  }
                });
                tag.forEach((item, index) => {
                  list.forEach(it => {
                    if (item.name == it) {
                      tag[index].selected = true;
                      tag[index].category_id;
                      that.tagId = that.tagId.concat(tag[index].category_id);
                      that.descript = res.data.description;
                    }
                  });
                });
                that.selectAddress([res.data.district_name, res.data.district]);
                //(that.companyAddress);
              }
            });
          }
        }
      });
    }
  },

  created() {
    var that = this;
  },
  mounted() {
    var that = this;
    that.query = that.$route.query;
    that.getKinds();
  },
  activated() {
    var that = this;
    // that.addr = that.companyAddress[0];
    // that.addrId = that.companyAddress[1];
    if (that.$route.query.descript != undefined) {
      that.descript = that.$route.query.descript;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "Ment") {
      this.reload();
    }
    next();
  }
};
</script>
<style lang='less' scoped>
.edit-boxs {
  padding: 0.2rem 0.44rem;
  font-size: 0.3rem;
  text-align: left;
  .edit-item {
    padding: 0.36rem 0 0.3rem;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    .price-box {
      display: flex;
      align-items: center;
      margin: 0.3rem 0;
      .price-item {
        height: 0.5rem;
        width: 2rem;
        border: 0.03rem solid rgba(21, 21, 21, 0.5) !important;
        border-radius: 0.1rem;
        text-align: center;
      }
    }
    .li {
      background: rgba(178, 178, 178, 0.2);
      opacity: 1;
      border-radius: 0.04rem;
      font-size: 0.24rem;
      padding: 0.05rem;
      border: 0.01rem solid transparent;
      color: rgba(51, 51, 51, 1);
      margin-right: 0.1rem;
      // position: relative;
      margin-top: 0.2rem;
      display: inline-block;
    }
    .lis {
      background: rgba(255, 67, 67, 0.2);
      color: rgba(255, 67, 67, 1);
      border: 0.01rem solid rgba(255, 67, 67, 1);
    }
    p {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
    }
    .printf-input {
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
      width: 95%;
      margin-top: 0.1rem;
      background: #fff;
    }
    .printf-input::-webkit-input-placeholder {
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }
  }
  .degree {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .van-cell {
    padding: 0.1rem 0;
  }
  /deep/ .van-cell img {
    max-width: 100%;
    margin: auto;
  }
  .placeholder:before {
    content: "";
    display: block;
    height: 1.5rem;
    width: 100%;
  }
}
</style>